import LocalStorage from '../services/session-storage';

export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_ID_ALTERACAO (state, id) {
    state.id_alteracao = id
  },
  SET_FULLNAME (state, name) {
    state.nome_completo = name
  },
  SET_USERNAME (state, name) {
    state.nome_usuario = name
  },
  SET_EMPRESAS (state, empresas) {
    state.empresas = empresas
  },
  SET_EMPRESA (state, empresa) {
    state.empresa_nome = empresa
  },
  SET_EMPRESA_ID (state, id) {
    state.empresa_id = id
  },
  SET_EMAIL (state, email) {
    state.email = email
  },
  SET_API (state, api) {
    state.api = api
  },
  SET_APIBOT (state, api) {
    state.api_bot = api
  },
  SET_FOTO (state, foto) {
    state.foto = foto
  },
  SET_LOGO (state, logo) {
    state.logo = logo
  },
  SHOW_EMPRESA (state) {
    state.show_empresa = true
  },
  HIDDEN_EMPRESA (state) {
    state.show_empresa = false
  },
  ACTIVE_BOT (state, status) {
    state.bot_ativo = status
  },
  SET_INDEXEMPRESA (state, index) {
    localStorage.setItem('INDEXEMPRESA', index)
    state.empresa_ativa = index
  },
  SET_TOKEN (state, token) {
    state.fb_page_token = token
  },
  SET_PERMITE_IMPRESSAO (state, permiteImpressao) {
    state.permite_impressao = permiteImpressao
  },
  SET_PERMITE_EMAIL (state, permiteEmail) {
    state.permite_email = permiteEmail
  },
  SET_FB_ID_EMPRESA (state, fbId) {
      localStorage.setItem('FB_ID', fbId)
      state.empresa_fb_id = fbId
  },
  SET_MODULOS_EMPRESA(state, modulos) {
    if(modulos) {
      let mod = modulos.map((modulo) => modulo.descricao)
      localStorage.setItem('modulos', mod)
      state.modulos = mod
    }
  },
  SET_USERTOKEN(state, response) {
    LocalStorage.setObject('token', response.token)
    state.auth.token = response.token
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js